import { ConfigProvider as PlotsConfigProvider } from '@ant-design/plots';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider as AntdConfigProvider } from 'antd';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppStateProvider } from '@/common/hooks/AppStateProvider';
import { ThemePreferenceProvider } from '@/common/theme/ThemeContext';
import useTheme from '@/common/theme/use-theme';
import AppRouter from '@/router';
import './global.css';

const queryClient = new QueryClient();

const App = () => {
  const { setThemeName, themeConfig, themeName } = useTheme();

  return (
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AppStateProvider>
            <ThemePreferenceProvider value={{ setThemeName, themeName }}>
              <AntdConfigProvider {...themeConfig}>
                <PlotsConfigProvider common={{ theme: 'classic' }}>
                  <AntdApp component="main">
                    <AppRouter />
                  </AntdApp>
                </PlotsConfigProvider>
              </AntdConfigProvider>
            </ThemePreferenceProvider>
          </AppStateProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};
export default App;
